/***************************************************************************************************
 * APPLICATION IMPORTS
 */

if (!Uint8ClampedArray.from) Uint8ClampedArray.from = (array) => new Uint8ClampedArray(array);
if (!Int32Array.from) Int32Array.from = (array) => new Int32Array(array);
if (!window['Notification']) window['Notification'] = { permission: 'denied' } as any;
if (!window['PushNotificationPermission']) window['PushNotificationPermission'] = { denied: 'denied' };

// For Object.values
if (!Object.values) Object.values = (o) => Object.keys(o).map(k => o[k]);

// @ts-expect-error - no types
window.__importDefault = function (mod) {
    return mod?.__esModule ? mod : { default: mod };
};
